import { useMemo } from 'react';
import { MultiplayerCallCapability } from '@doxyme/extensions-bridge';
import { getSessionParticipantsMap } from '../../../features/session/session.selectors';
import { getAllMembers } from '../../../features/realtime/realtime.selectors';
import { useAppSelector } from '../../useReduxToolkit';
import { useExtensionsMultiplayer } from './useExtensionsMultiplayer';

export function useExtensionsMultiplayerCall(): void {
  const sessionParticipantsMap = useAppSelector(getSessionParticipantsMap);
  const members = useAppSelector(getAllMembers);
  const callMembers = useMemo(
    () => members.filter((p) => sessionParticipantsMap[p.identity.id]),
    [sessionParticipantsMap, members],
  );

  useExtensionsMultiplayer(MultiplayerCallCapability, callMembers);
}
